(function() {
  'use strict';

  angular.module('eclipseApp.checkout').controller('buyConfirmationCtrl', [
    '$rootScope',
    '$scope',
    'order',
    'buyService',
    'cartManager',
    'notifier',
    'commonService',
    '$state',
    'uteModal',
    'uteLocale',
    'buyUtils',
    'dtmService',
    'dtmServiceConstants',
    '$timeout',
    'brtSwitchCMS',
    '$window',
    function(
      $rootScope,
      $scope,
      order,
      buyService,
      cartManager,
      notifier,
      commonService,
      $state,
      uteModal,
      uteLocale,
      buyUtils,
      dtmService,
      dtmServiceConstants,
      $timeout,
      brtSwitchCMS,
      $window
    ) {
      console.log('buyConfirmationCtrl:LOADED (shoppingCartCached) ', buyService.shoppingCartCached);

      buyService.getServiceAddressDetails().then(
        function(data) {
          $scope.searchLocation = data.address.postalCode;
        },
        function(err) {
          //noop
        }
      );

      var _self = {};

      $scope.isHybridFlow = brtSwitchCMS.brtSwitch.isHybridFlow;

      _self.serviceAddress = '';
      _self.storeAddress = '';
      _self.orderId = '';
      _self.repId = '';
      _self.modemSerialNumber = '';
      _self.modemName = '';

      _self.lang = buyUtils.getAppLang();

      $scope.review = {};
      $scope.review.language = buyUtils.getAppLang();
      $scope.promoOfferId = $rootScope.promoOfferId ? $rootScope.promoOfferId : null;
      $scope.review.promoOfferId = $rootScope.promoOfferId ? $rootScope.promoOfferId : null;
      $scope.discountOffers = $rootScope.discountOffers ? $rootScope.discountOffers : null;
      $scope.review.discountOffers = $rootScope.discountOffers ? $rootScope.discountOffers : null;

      if (order) {
        $scope.order = order;
        $scope.orderSummary = order.orderSummaryData;
        _self.orderId = order.orderID;

        if (order.billingDetails && order.billingDetails.billingAddress) {
          _self.serviceAddress = order.billingDetails.billingAddress;
        }

        if (order.equipmentDetails && order.equipmentDetails.serialNumber) {
          _self.modemSerialNumber = order.equipmentDetails.serialNumber;
        }
        //FUSS-1519 - DTM tracking for internet confirmation step 6
        var tierInCart = cartManager.internet.tierInCart();
        if (tierInCart) {
          if (tierInCart.selectedOffer && tierInCart.selectedOffer.offerPrice) {
            dtmService.setVar(
              dtmServiceConstants.dtmRules.buyInternet.selectedProduct,
              tierInCart.selectedOffer.offerId
            );
            dtmService.setVar(
              dtmServiceConstants.dtmRules.buyInternet.productPrice,
              tierInCart.selectedOffer.offerPrice.price
            );
          }
          dtmService.setVar(dtmServiceConstants.dtmRules.buyInternet.confirmOrder.orderNumber, order.orderID);
          dtmService.direct(dtmServiceConstants.dtmRules.buyInternet.confirmOrder.ruleName);

          /* DSO-15392 start */
          /* No need to handle refresh scenario for confirmation page */
          if (
            $scope.promoOfferId === null ||
            ($scope.review.promoOfferId === null && $scope.discountOffers === null) ||
            $scope.review.discountOffers === null
          ) {
            if (
              commonService.customerHasInternetService &&
              commonService.internetAccountStatus !== 'SUSPENDED' &&
              commonService.internetAccountStatus !== 'CANCELLED'
            ) {
              $scope.promoOfferId = null;
              $scope.review.promoOfferId = null;
            } else {
              //$timeout(function(){
              var isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
              if (isOfferIdEligible === null) {
                buyService.getInternetPromos().then(function(data) {
                  if (data) {
                    isOfferIdEligible = buyService.isPromoOfferIdEligible($scope.review.tier.selectedOffer.offerId);
                    $scope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                    $scope.review.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                    $scope.discountOffers = buyService.getDiscountOffers();
                    $scope.review.discountOffers = buyService.getDiscountOffers();
                  }
                });
              } else {
                $scope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                $scope.review.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                $scope.discountOffers = buyService.getDiscountOffers();
                $scope.review.discountOffers = buyService.getDiscountOffers();
              }
              $rootScope.promoOfferId = $scope.promoOfferId;
              $rootScope.discountOffers = $scope.discountOffers;
              //},0);
            }
          }
          if (
            $rootScope.discountOffers === null ||
            ($scope.review.discountOffers === null && !$rootScope.ruiMethods.user.is.loggedIn())
          ) {
            buyService.getInternetPromos().then(function(data) {
              var response = data;
              $rootScope.discountOffers = response;
              $scope.review.discountOffers = response;
            });
          }
          /* DSO-15392 end */
        }
      }

      if ($rootScope.userInfo && $rootScope.userInfo.cfaInfo) {
        _self.repId = $rootScope.userInfo.cfaInfo.userID;
        _self.storeAddress = $rootScope.userInfo.cfaInfo.storeLocation;
      }

      // if ($scope.forms && $scope.forms.createUser && $scope.forms.createUser.data) {
      //   _self.serviceAddress = $scope.forms.createUser.data.serviceAddress;
      // }

      // if ($scope.forms &&
      //     $scope.forms.fulfillment &&
      //     $scope.forms.fulfillment.options &&
      //     $scope.forms.fulfillment.options.takeItWithYou){

      //   _self.modemSerialNumber = $scope.forms.fulfillment.options.takeItWithYou.modemSerialNumber;
      // }

      _self.modemName = _self.lang == 'en' ? 'Fido Wi-Fi Modem' : 'Modem Wi-Fi Fido';

      $scope.review.tier = cartManager.internet.tierInCart();

      $scope.navigateAwayFromCheckout = $scope.buyMethods.navigateAwayFromCheckout;

      $scope.storeLocatorConfig = {
        pagination: false,
        searchBox: true,
        address: getCachedStoreAddress()
      };

      $scope.viewStoreLocator = function() {
        uteModal.open({
          templateUrl: 'modules/checkout/views/store-locator-modal.html',
          controller: 'storeLocatorModalCtrl',
          size: 'lg',
          data: {
            session: $scope.forms
          }
        });
      };

      console.info($scope.forms);

      if ($scope.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
        if ($scope.forms && $scope.forms.createUser && $scope.forms.createUser.data) {
          _self.serviceAddress = $scope.forms.createUser.data.serviceAddress;
        }
        $scope.printData = {
          accountNumber: commonService.wirelessAccountNumber,
          financialAccountID:
            $scope.forms &&
            $scope.forms.paymentOptions &&
            $scope.forms.paymentOptions.data &&
            $scope.forms.paymentOptions.data.financialAccountID
              ? $scope.forms.paymentOptions.data.financialAccountID
              : '',
          address: _self.serviceAddress,
          cbpId: order.cbpId ? order.cbpId : '',
          repId: $rootScope.ruiMethods.agent.shortName(), //_self.repId, // userInfo.userId
          currentDate: moment().format('ll'),
          currentTime: moment().format('hh:mm:ss A'),
          storeAddress: $rootScope.ruiMethods.agent.storeAddress(), //_self.storeAddress,
          storeName: $rootScope.ruiMethods.agent.storeName(), //_self.storeAddress,
          contactId: order.contactId ? order.contactId : '',
          orderId: _self.orderId,
          storeCode: $rootScope.ruiMethods.agent.storeCode(),
          modemName: _self.modemName, //?
          customerAddress: _self.serviceAddress,
          modemData: {
            modemSerialNumber: _self.modemSerialNumber,
            workOrderNo: _self.orderId // in checkout map to orderId
          },
          firstName: $scope.forms.createUser.firstName,
          lastName: $scope.forms.createUser.lastName,
          shippingAddress: order.shippingAddress,
          billingAddress: order.billingAddress,
          techInstall: order.techInstall,
          productDetails: order.productDetails,
          paymentMethod: order.paymentMethod,
          billingMethod: order.billingMethod,
          maestroId: order.maestroId,
          fulfilType: order.fulfilType,
          fulfilOption: order.fulfilOption,
          serviceReqDate: order.serviceReqDate,
          dealerCode: order.dealerCode
          // issued: 'ISSUED' //(for Pick Ups) // status
        };
        console.log(JSON.stringify($scope.printData));
      } else {
        $scope.printData = {
          accountNumber: commonService.wirelessAccountNumber,
          financialAccountID:
            $scope.forms &&
            $scope.forms.paymentOptions &&
            $scope.forms.paymentOptions.data &&
            $scope.forms.paymentOptions.data.financialAccountID
              ? $scope.forms.paymentOptions.data.financialAccountID
              : '',
          address: _self.serviceAddress,
          repId: $rootScope.ruiMethods.agent.shortName(), //_self.repId, // userInfo.userId
          currentDate: moment().format('ll'),
          currentTime: moment().format('hh:mm:ss A'),
          storeAddress: $rootScope.ruiMethods.agent.storeAddress(), //_self.storeAddress,
          storeName: $rootScope.ruiMethods.agent.storeName(), //_self.storeAddress,

          orderId: _self.orderId,
          storeCode: $rootScope.ruiMethods.agent.storeCode(),
          modemName: _self.modemName, //?
          customerAddress: _self.serviceAddress,
          modemData: {
            modemSerialNumber: _self.modemSerialNumber,
            workOrderNo: _self.orderId // in checkout map to orderId
          },
          firstName: $scope.forms.createUser.firstName,
          lastName: $scope.forms.createUser.lastName,
          issued: 'ISSUED' //(for Pick Ups) // status
        };
      }

      $scope.print = function() {};

      cartManager.cleanCart().then(
        function(res) {
          console.log('cart is cleaned');
        },
        function(resErr) {
          _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
          _satellite.track('bfa-fhsi-error');
          notifier.notify.error();
        }
      );

      if ($rootScope.ruiMethods.user.is.agent()) {
        $window.sessionStorage.setItem('agentSelectedOffer', '{}');
      }

      if (buyService.getSession('profile')) {
        buyService.cleanSessions();
      }

      function getCachedStoreAddress() {
        if ($scope.forms.fulfillment.selectedOption === 'pickupAtStore') {
          return $scope.forms.fulfillment.options.pickupAtStore.selectedPosition;
        }
      }
      //DSO-12648 removing extra space on confirmation page for anonymous customers
      if (!$rootScope.ruiMethods.user.is.loggedIn() && !$rootScope.ruiMethods.user.is.agent()) {
        $timeout(function() {
          $('body').removeClass('body-extra-spacing');
        });
      } else if ($rootScope.ruiMethods.user.is.agent() && !$rootScope.ruiMethods.showMyAccountLink()) {
        $timeout(function() {
          $('body').removeClass('body-extra-spacing');
        });
      }
    }
  ]);
})();
